import GoogleAnalytics from './google_analytics'
export default GoogleAnalytics
